import { motion } from "framer-motion";
import "./Header.css";
import { Container, Col, Row } from "react-bootstrap";
import MonetaLogo from "../common/MonetaLogo";
import Samsung from "../../assets/images/Samsung.png";
import Iphone from "../../assets/images/iphonedw.png";
import IphoneMockUp from "../../assets/images/iphoneMockup.png";
import SamsungFront from "../../assets/images/samsungMockup.png";

const divVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 1.5, ease: "easeInOut" },
  },
};

const Header = ({ headingData }) => {
  const first = headingData?.first_header_text ?? "";
  const second = headingData?.second_header_text ?? "";
  const description = headingData?.header_description ?? "";

  return (
    <motion.div variants={divVariants} initial="hidden" animate="visible">
      <Container className="header">
        <Row className="header_wrapper">
          <Col lg={6} md={6} sm={12} className="mt-5 logo">
            <MonetaLogo className="cls-1" />
            <div className="head_info">
              <h3>{first}</h3>
              <h3>{second}</h3>
              <p className="mt-5 mb-5">{description}</p>
              <a
                href="https://play.google.com/store/apps/details?id=com.finhelper"
                target="_blank"
                rel="noreferrer noopener"
                className="samsung-wrapper"
              >
                <img src={Samsung} alt="Get Moneta on Samsung Galaxy Store" />
              </a>
              <a
                href="https://apps.apple.com/app/moneta-al/id1623391075"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={Iphone} alt="Get Moneta on the App Store" />
              </a>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12} className="overlap">
            <img
              src={SamsungFront}
              alt=""
              role="presentation"
              className="back-image"
            />
            <img
              src={IphoneMockUp}
              alt=""
              role="presentation"
              className="front-image"
            />
          </Col>
        </Row>
      </Container>
    </motion.div>
  );
};

export default Header;
